"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonClose = exports.StyledModalBackdrop = exports.StyledModal = exports.GlobalStyle = void 0;

const utils_1 = require("../../helpers/utils");

const styled_components_1 = __importStar(require("styled-components"));

exports.GlobalStyle = (0, styled_components_1.createGlobalStyle)`
  body {
    position: fixed;
    top: ${(0, utils_1.isBrowser)() && window.scrollY};
    width: 100%;
  }
`;
exports.StyledModal = styled_components_1.default.div`
  margin: 13px 20px 20px;
`;
exports.StyledModalBackdrop = styled_components_1.default.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${props => props.backgroundColor || `${props.theme.colors.black_main}80`};
  opacity: ${props => props.opacity || 1};
  z-index: 10000;
`;
exports.StyledButtonClose = styled_components_1.default.span`
  position: absolute;
  right: 15px;
  top: 16px;
  width: 21px;
  height: 21px;
  cursor: pointer;
`;